// extracted by mini-css-extract-plugin
export default {"layout":"default_layout__hoQb1","layout_tabs":"default_layout_tabs__DAlWp"};